import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=528765eb&scoped=true"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"
import style0 from "./Press.vue?vue&type=style&index=0&id=528765eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528765eb",
  null
  
)

export default component.exports